<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 flex-header text-center text-sm-left mb-0">
        <h3 class="page-title">Wydatki</h3>
        <d-button
          theme="success"
          @click="$router.push({name: 'expense-new'})">
          <i class="material-icons">add</i> Dodaj wydatek
        </d-button>
        <d-button
          @click="exportExpenses"
          :class="{ isLoading : zip_downloading }">
          <i class="material-icons">save_alt</i> Pobierz listę
        </d-button>
      </div>
    </div>

    <!-- Default Light Table -->
    <template v-if="loadError">
      <d-alert
        show
        theme="warning">
        Wczytywanie danych nie powiodło się.
        <a
          href="javascript:window.location.reload();"
          class="alert-link">
          Odśwież stronę
        </a>
        aby spróbować ponownie.
      </d-alert>
    </template>
    <template v-else>
      <transition name="fade">
        <ExpenseTable />
      </transition>
    </template>
  </div>
</template>

<script>
import FileSaver from 'file-saver';
import ListUtils from '@/utils/ListUtils.js';
import ExpenseTable from '@/components/expense/list/organism/ExpenseTable.vue';

export default {
  name: 'ExpensesList',
  components: {
    ExpenseTable
},
  data () {
    return {
      actionInProgress: false,
      loaded: false,
      loadError: false,
      zip_downloading: false
    }
  },
  methods: {
    exportExpenses () {
      this.zip_downloading = true;
      axios.post('api/expenses/export',
        {page: this.current_page, search: this.filters},
        {responseType: 'blob'}).then(response => {
        let blob = new File(
          [response.data],
          'lista_wydatkow_' + Vue.getCurrentDate() + '_.xlsx'
        );
        FileSaver.saveAs(blob);
        this.zip_downloading = false;
        // this['exporting_' + type] = false;
      }).catch(error=>{
        this.zip_downloading = false;
        // this['exporting_' + type] = false;
      })
    }
  }
}
</script>

<style>
.table td strong{
    font-weight: bold;
}
.action-cell, .id-cell{
    width: 200px;
}
.name-cell{
    width: 190px;
}
.amount-cell{
    width: 100px;
}
.title-cell{
    width: 190px;
}
.recipent-cell{
    width: 200px;
}

.payment_type-cell{
    width: 190px;
}
</style>
